<div class="file-picker">
	<input #picker type="file" [disabled]="disabled" [multiple]="isMultiSelect" [accept]="formatFilter" (change)="handleFiles()" (click)="cancelPropagation($event)" style="display: none; pointer-events: none" />
	<div>
		<ng-content></ng-content>
	</div>
</div>
